import { useMutation } from '@apollo/client/react';
import { SPLIT_REQUEST_MUTATION } from './useSplitRequest.gql';
export const useSplitRequest = () => {
  const [splitRequestMutation] = useMutation(SPLIT_REQUEST_MUTATION);

  return (requestId: string) =>
    splitRequestMutation({
      variables: {
        requestId: requestId,
      },
    });
};
